/**
 * ★ "YEARS OF PRACTICE" (design 25; design 24, T25 - the prototype's "how long you've been working
 * in your primary area"). A whole number from 0 to 80, optional, and shown on the public page as
 * "12 years of practice" whenever it is set - it has no switch (the owner, 2026-10-19).
 *
 * The form keeps it as the typed text (../domain/form.ts): an empty box clears it, and anything that
 * is not a whole number in the bound is refused on screen before a save - the server's 422 is the
 * same rule (`PROFILE_LIMIT_EXCEEDED`).
 */
import { NumberInput } from '@mantine/core';
import type { ReactNode } from 'react';
import { useTranslation } from '../../../i18n';
import { YEARS_OF_PRACTICE } from '../domain/limits';

export interface YearsOfPracticeFieldProps {
  readonly value: string;
  readonly error?: string | undefined;
  readonly onChange: (value: string) => void;
}

export function YearsOfPracticeField({
  value,
  error,
  onChange,
}: YearsOfPracticeFieldProps): ReactNode {
  const { t } = useTranslation('application');
  return (
    <div id="apply-years-of-practice">
      <NumberInput
        label={t('yearsOfPractice.label')}
        description={t('yearsOfPractice.description')}
        placeholder="12"
        min={YEARS_OF_PRACTICE.min}
        max={YEARS_OF_PRACTICE.max}
        allowDecimal={false}
        allowNegative={false}
        clampBehavior="none"
        hideControls
        value={value}
        error={error}
        onChange={(next) => {
          onChange(String(next));
        }}
        // The box is narrow, never the label and the description, which keep one line.
        styles={{ input: { maxWidth: '12rem' } }}
      />
    </div>
  );
}
